<template>
    <div :id="buttonBarAnchorId"></div>
    <div
        :id="buttonBarId"
        ref="buttonBar"
        class="button-bar mt-[42px] mb-[46px] flex gap-2.5 items-center items- sm:flex-wrap-reverse justify-between align-items-center align-self-center"
        :class="buttonBarClasses"
    >
        <div
            class="flex-grow-1 flex gap-2"
            :class="{
                'sm:flex-row flex-col-reverse items-start sm:items-center': !centerButtonsOnMobile,
                'items-center': centerButtonsOnMobile
            }"
        >
            <slot />
        </div>
        <div class="flex items-center">
            <slot name="button-bar-append" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";

const props = defineProps({
    sticky: {
        type: Boolean,
        default: false
    },
    centerButtonsOnMobile: {
        type: Boolean,
        default: false
    }
});

const barIsStuck = ref(false);
const buttonBarId = `button-bar-${Math.floor(Math.random() * 1000)}`;
const buttonBarAnchorId = `${buttonBarId}-anchor`;

const stickyClasses = computed(() => {
    const baseClasses = ["sticky bottom-3 sm:bottom-10 bg-white "];
    if (props.sticky && barIsStuck.value) {
        baseClasses.push("py-2 px-4 shadow-xl w-[110%] -ml-[5%]");
    }

    return baseClasses.join(" ");
});

const buttonBarClasses = computed(() => ({
    [stickyClasses.value]: props.sticky,
    // Alignment
    "flex-col-reverse sm:flex-row items-center sm:items-start": props.centerButtonsOnMobile
}));

function getElementDistanceFromBottom(element: HTMLElement | null) {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    return window.innerHeight - rect.bottom;
}

function checkScrollPosition() {
    const scrollPosition = window.innerHeight + window.scrollY;
    const distanceFromBottomOfScreen = getElementDistanceFromBottom(document.getElementById(buttonBarAnchorId));
    const threshold = document.body.offsetHeight - distanceFromBottomOfScreen;

    barIsStuck.value = scrollPosition <= threshold;
}

onMounted(() => {
    window.addEventListener("scroll", checkScrollPosition);
    checkScrollPosition();
});
onBeforeUnmount(() => {
    window.removeEventListener("scroll", checkScrollPosition);
});
</script>

<style></style>
